export enum EFolderType {
  Folder,
  Directory,
  Archive = 'archive',
  Template = 'template',
}
